import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchers } from "../lib/api";

const Pill = ({ ev }) => {
  const live = ev.status === "LIVE" || ev.status === "HT";
  return (
    <div className="flex shrink-0 items-center gap-2 border-r border-border px-5 py-2 text-sm">
      {live ? (
        <span className="flex items-center gap-1 overline-eyebrow text-primary">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary animate-live-pulse" />
          {ev.status === "HT" ? "HT" : ev.clock}
        </span>
      ) : (
        <span className="overline-eyebrow text-muted-foreground">FT</span>
      )}
      <span className="font-medium text-foreground">{ev.home.name}</span>
      <span className="font-display text-base text-primary">
        {ev.home.score ?? "–"} - {ev.away.score ?? "–"}
      </span>
      <span className="font-medium text-foreground">{ev.away.name}</span>
      <span className="hidden text-[11px] uppercase tracking-wider text-muted-foreground md:inline">· {ev.league}</span>
    </div>
  );
};

export const LiveTicker = () => {
  const { data: live } = useQuery({ queryKey: ["ticker-live"], queryFn: fetchers.live, refetchInterval: 60_000 });
  const { data: past } = useQuery({ queryKey: ["ticker-past"], queryFn: () => fetchers.past("all", 20), refetchInterval: 300_000 });

  const events = [...(live?.events || []), ...(past?.events || [])].slice(0, 24);
  if (events.length === 0) {
    return (
      <div className="border-y border-border bg-card/60 py-2 text-center text-xs text-muted-foreground">
        Loading live scores…
      </div>
    );
  }
  const loop = [...events, ...events];
  return (
    <div data-testid="live-ticker" className="relative overflow-hidden border-y border-border bg-card/70">
      <div className="absolute left-0 top-0 z-10 flex h-full items-center bg-primary px-3 overline-eyebrow text-primary-foreground">
        {live?.count ? `${live.count} Live` : "Scores"}
      </div>
      <div className="flex w-max animate-marquee pl-28 will-change-transform hover:[animation-play-state:paused]">
        {loop.map((ev, i) => (
          <Pill key={`${ev.id}-${i}`} ev={ev} />
        ))}
      </div>
    </div>
  );
};

export default LiveTicker;
